export default __webpack_public_path__ + "static/media/dealer.cf5f7de9.svg";